/**
 * Crisp Chat Integration
 * Loads Crisp chat widget and syncs user session data
 */

window.$crisp = window.$crisp || [];

// Enable Crisp safe mode to isolate styles and avoid layout conflicts
try { window.$crisp.push(['safe', true]); } catch (_) {}

window.CRISP_WEBSITE_ID = 'f9dd507d-f8d2-470c-8075-748fc3ff1990';

window.CRISP_READY_TRIGGER = function() {
  let hasCustomName = window.$crisp.get('session:data', 'hasCustomName');
  let name = window.$crisp.get('user:nickname');

  if (
    window.current_user?.username &&
    window.current_user.username !== name &&
    hasCustomName !== 'has' &&
    name.startsWith('visitor')
  ) {
    window.$crisp.push(['set', 'user:nickname', [window.current_user.username]]);
  }
};

/**
 * Initialize Crisp session data from current_user
 */
function cInit() {
  // Ensure $crisp array/object exists before pushing commands
  if (!window.$crisp || typeof window.$crisp.push !== 'function') return;
  if (!window.current_user) return;

  if (window.current_user.id || window.current_user.guest_id) {
    window.$crisp.push([
      'set',
      'session:data',
      [
        [
          ['place', window.location.pathname],
          [
            'cnid_link',
            `https://crm.warmlyyours.com/en-US/customers/${window.current_user.id || window.current_user.guest_id}`
          ]
        ]
      ]
    ]);
  }

  if (window.current_user.id) {
    window.$crisp.push([
      'set',
      'session:data',
      [
        [
          ['user_id', window.current_user.id || null],
          ['cnid', `CN${window.current_user.id}`],
          ['created_at', window.current_user.created_at || null]
        ]
      ]
    ]);
  }

  if (window.current_user.guest_id) {
    window.$crisp.push([
      'set',
      'session:data',
      [
        [
          ['guest_id', window.current_user.guest_id],
          ['guest_name', window.current_user.username]
        ]
      ]
    ]);
  }

  if (window.current_user.company) {
    window.$crisp.push(['set', 'session:data', [[['company', window.current_user.company]]]]);
  }

  if (window.current_user.email) {
    window.$crisp.push([
      'set',
      'user:email',
      [window.current_user.email, window.current_user.email_hash]
    ]);
  }

  if (window.current_user.cartId) {
    window.$crisp.push([
      'set',
      'session:data',
      [
        [
          ['cartId', window.current_user.cartId || null],
          [
            'current_order_link',
            `https://crm.warmlyyours.com/en-US/orders/${window.current_user.cartId}`
          ],
          ['cartQty', window.current_user.cartQty || null],
          ['cartTotal', window.current_user.cartTotal || null]
        ]
      ]
    ]);
  }

  if (window.current_user.src) {
    window.$crisp.push(['set', 'session:data', [[['src', window.current_user.src]]]]);
  }

  if (window.current_user.userLogin) {
    window.$crisp.push([
      'set',
      'session:data',
      [[['userLogin', window.current_user.userLogin]]]
    ]);
  }

  if (window.current_user.rep) {
    window.$crisp.push(['set', 'session:data', [[['rep', window.current_user.rep]]]]);
  }

  window.$crisp.push([
    'set',
    'session:data',
    [
      [
        ['isGuest', window.current_user.isGuest ? 'yes' : 'no'],
        ['isUser', window.current_user.isUser ? 'yes' : 'no'],
        ['isEmp', window.current_user.isEmp ? 'yes' : 'no'],
        ['isLoggedIn', window.current_user.isLoggedIn ? 'yes' : 'no']
      ]
    ]
  ]);
}

const loadOnScroll = false;

/**
 * Load Crisp chat script
 */
function loadCrisp(async = true) {
  console.log('loadCrisp');
  
  // Avoid injecting the script multiple times on Turbo/SPA navigations
  if (!window.CRISP_LOADED) {
    const script = document.createElement('script');
    script.src = 'https://client.crisp.chat/l.js';
    script.async = async ? 1 : 0;
    document.head.appendChild(script);
    window.CRISP_LOADED = true;
  }
  
  // Queue session/user data immediately; Crisp will replay once script is ready
  cInit();
}

// Initialize based on configuration
// Note: Room planner pages now use data-controller="room-planner-edit" for lazy loading
if (window.LC_ENABLED && document.querySelector('[data-controller*="room-planner-edit"]')) {
  console.debug('Eager load Crisp for room planner');
  loadCrisp(false);
} else if (window.LC_ENABLED && loadOnScroll) {
  window.addEventListener('scroll', () => setTimeout(loadCrisp, 1000), { once: true });
} else if (window.LC_ENABLED) {
  // Load on DOMContentLoaded
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => loadCrisp());
  } else {
    loadCrisp();
  }
}

// Reset Crisp session on sign out
document.getElementById('nav-sign-out')?.addEventListener('click', () => {
  window.$crisp?.push(['do', 'session:reset']);
});

// Ensure Crisp remains initialized across Turbo visits without duplicating script
document.addEventListener('turbo:load', () => {
  if (window.LC_ENABLED) cInit();
});
